export default function ProjectPage() {
    return <h1>Project</h1>
  }
  